import React, { useState } from 'react';
import { motion, AnimatePresence } from 'framer-motion';

export const Search = () => {
  const [isFocused, setIsFocused] = useState(false);
  const [searchTerm, setSearchTerm] = useState('');
  const [showMessage, setShowMessage] = useState(false);

  const handleKeyDown = (e) => {
    if (e.key === 'Enter') {
      setShowMessage(true);
    }
  };

  return (
    <div className="relative w-[40vw]">
      <input
        type="text"
        placeholder="What are you looking for?"
        value={searchTerm}
        onChange={(e) => setSearchTerm(e.target.value)}
        onFocus={() => {
          setIsFocused(true);
          setShowMessage(false);
        }}
        onBlur={() => setTimeout(() => setIsFocused(false), 200)}
        onKeyDown={handleKeyDown}
        className="px-4 w-full py-2 rounded-full bg-gray-700 text-white placeholder-gray-400 focus:outline-none focus:ring-2 focus:ring-blue-500"
      />

      <AnimatePresence>
        {isFocused && (
          <motion.div
            initial={{ opacity: 0, y: -10 }}
            animate={{ opacity: 1, y: 0 }}
            exit={{ opacity: 0, y: -10 }}
            transition={{ duration: 0.3 }}
            className="absolute left-0 right-0 mt-2 p-6 bg-gray-900 bg-opacity-90 text-white rounded-2xl shadow-lg z-40"
          >
            {showMessage ? (
              <div className="text-center text-sm font-medium">
                <p>
                  🚧 Finance general search is{' '}
                  <span className="text-yellow-400">not configured</span> or{' '}
                  <span className="text-yellow-400">pending configuration</span>
                  .
                </p>
                <p className="mt-1 text-gray-400 italic">
                  Please contact your administrator.
                </p>
              </div>
            ) : (
              <div className="text-center text-sm text-gray-400">
                Type and press Enter to search.
              </div>
            )}
          </motion.div>
        )}
      </AnimatePresence>
    </div>
  );
};
